export { default } from './ScoreCard';



// WEBPACK FOOTER //
// ./src/js/common/components/ScoreCard/index.js